import {extendComponent} from "juis-components/ComponentUtils.js";
import Property from "juis-components/Property.js";
import Component from "juis-components/Component.js";
import UrlComponentMixin from "../components/UrlComponentMixin.js";
import {concatenateUrls} from "juis-router/NavigationUtils.js";
import HTML from "../utils/HTML.js";

const EXTERNAL_LINK_ICON = "external-link-alt";

// The icon span, followed by the text span when there is a text. Without text there is nothing to put in the second
// span, and an empty one would only add spacing.
const getIconAndTextHtml = (icon, iconColor, text) => {
    const style = iconColor ? `style="color:${iconColor};"` : "";
    const textSpan = text ? `\n            <span>${text}</span>` : "";
    return `<span class="icon"><i class="fas fa-${icon}" ${style}></i></span>${textSpan}`;
};

const createLink = (url, text, icon, iconColor) => new Link(function () {
    this.text = text ?? url;
    this.url = url;
    if (icon || iconColor) {
        this.icon = icon || "circle";
        this.iconColor = iconColor;
    }
});

// Opens in a new tab, which is shown with a small "external link" icon after the text. Without a text the url
// itself is shown. An icon (and its color) can be given to make it look like the other links, see createLink.
const createBlankLink = (url, text, icon, iconColor) => {
    return new Component(function () {
        this.getNode().setAttribute("href", url);
        const label = typeof text === "string" && text ? text : url;
        const content = icon || iconColor ? getIconAndTextHtml(icon || "circle", iconColor, label) : label;
        this.getNode().setInnerHtml(`${content}<span class="icon is-small ml-1"><i class="fas fa-${EXTERNAL_LINK_ICON}"></i></span>`);
        this.getNode().setAttribute("target", "_blank");
        this.getNode().setAttribute("rel", "noopener noreferrer");
    }, [], HTML.A);
};

const Link = extendComponent(Component, function () {
    this.callback(UrlComponentMixin);
    this.registerDomEvents("click");
    this.preventDefaultDomEvent("click");


    const setContent = () => {
        if (!this.icon) {
            this.getNode().setText(this.text);
            return;
        }
        this.getNode().setInnerHtml(getIconAndTextHtml(this.icon, this.iconColor, this.text));
    };
    this.text = new Property(setContent);
    this.icon = new Property(setContent);
    this.iconColor = new Property(setContent);
    this.autoBlur = false;
    this.replaceHistory = false;
    this.on("click", () => {
        if (this.url && this.url !== "#" && this.url !== "/") {
            const eventData = {replaceHistory: this.replaceHistory};
            if (this.isRelative()) {
                this.navigate(concatenateUrls(this.baseUrl, this.url), {}, eventData);
            } else {
                this.navigate(this.url, {}, eventData);
            }
        }
        if (this.autoBlur) {
            this.getNode().getActualElement().blur();
        }
    });
    this.extendProperty("url", function (value) {
        this.getNode().setAttribute("href", value);
    });

}, "link", "A");

export {Link as default, createLink, createBlankLink};
